module.exports = __webpack_public_path__ + "static/media/5a4899e9-6326-4ccc-813f-343720f8628e.cea0ec36.JPG";